import './FundAdvancedCriteriaPopup.css';
import '../../../Common/typography.css';
import { FundCriteria, FundCriteriaSetter } from '../../../../types/fundScreener.type';
import FundCriteriaSelect from '../FundCriteriaSelect/FundCriteriaSelect';
import FundCriteriaDetailList from '../FundCriteriaDetailList/FundCriteriaDetailList';
import { Box } from '@mui/material';

export interface FundAdvancedCriteriaPopupProps {
  market: string;
  tempCriteria: FundCriteria[];
  setTempCriteria: FundCriteriaSetter;
  onGetResults: () => void;
  onCancel: () => void;
  token: string;
}

const FundAdvancedCriteriaPopup = ({
  market,
  tempCriteria,
  setTempCriteria,
  onGetResults,
  onCancel,
  token,
}: FundAdvancedCriteriaPopupProps) => {
  const handleClearAll = () => {
    setTempCriteria(tempCriteria.map((item) => ({ ...item, selected: false })));
  };

  const hasPendingMinMax = tempCriteria.some(
    (item) => item.selected && (item.pendingMinMax || item.minMaxUnavailable),
  );

  return (
    <Box className="fund-advanced-criteria-popup">
      <Box className="fund-advanced-criteria-popup-body">
        <Box className="fund-advanced-criteria-popup-select-pane">
          <FundCriteriaSelect
            criteria={tempCriteria}
            setCriteria={setTempCriteria}
          />
        </Box>
        <Box className="fund-advanced-criteria-popup-detail-pane">
          <FundCriteriaDetailList
            market={market}
            tempCriteria={tempCriteria}
            selectedCriteria={tempCriteria.filter((item) => item.selected)}
            setCriteria={setTempCriteria}
            token={token}
          />
        </Box>
      </Box>

      <Box className="fund-advanced-criteria-popup-footer">
        <button
          type="button"
          className="fund-advanced-criteria-popup-button body-m-bold"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="fund-advanced-criteria-popup-button body-m-bold"
          onClick={handleClearAll}
        >
          Reset All
        </button>
        <button
          type="button"
          className="fund-advanced-criteria-popup-button fund-advanced-criteria-popup-button-primary body-m-bold"
          disabled={hasPendingMinMax}
          onClick={onGetResults}
        >
          Get Results
        </button>
      </Box>
    </Box>
  );
};

export default FundAdvancedCriteriaPopup;
